/**
 * Resolves once the app knows if a shopper can have a session.
 *
 * Before this point there is no token, and "no token" does not mean "signed out".
 * Profile reads wait for this signal, so the header does not show the signed-out
 * buttons and then change them.
 */
let resolveAuthReady: () => void = () => undefined;

export const authReady: Promise<void> = new Promise((resolve) => {
  resolveAuthReady = resolve;
});

/** Send this when auth setup ends, or when the store has no auth. It is safe to send more than once. */
export const markAuthReady = () => resolveAuthReady();
